import React from 'react'
import { Link } from 'react-router'
import { Analytics } from 'common-frontend';

import { AnalyticsUtils, Enum} from 'utils'
import { SEOFixesCard, BlogFixesCard, SpeedFixesCard, Button } from 'components'

import './recommendedJobs.scss'

import Avatar from 'material-ui/Avatar'
import FlatButton from 'material-ui/FlatButton'
import {
  Card,
  CardMedia,
  CardTitle,
  CardText,
  CardActions
} from 'material-ui/Card'

export default class RecommendedJobs extends React.Component {
  static propTypes = {
    checks: React.PropTypes.object.isRequired
  }
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  render() {
    let recommendations = []

    let seoProblemsTofix = false
    let speedToFix = false
    let blogToFix = false

    if (!this.props.checks.isEmpty()) {
      let checks = this.props.checks.toJS()
      for (let check of checks) {
        if (check.typeId === Enum.CheckTypes.seoproblems.id) {
          if (check.verdict === Enum.Verdict.MajorIssuesUserShouldFix || check.verdict === Enum.Verdict.IssuesUserShouldConsiderFix) {
            seoProblemsTofix = true
            recommendations.push(<SEOFixesCard key='seofixescard' source={Enum.BlimponLinkLocations.checksPage} />)
          }
        } else if (check.typeId === Enum.CheckTypes.blog.id) {
          if (check.enabled === true && check.verdict !== Enum.Verdict.NoIssuesNoUserActionRequired) {
            blogToFix = true
            recommendations.push(<BlogFixesCard key='blogfixescard' source={Enum.BlimponLinkLocations.checksPage} />)
          }
        }
      }
    }

    if (this.context.currentUser.activeCharge === false && this.context.currentUser.provider === 'shopify') {
      recommendations.push(this.renderUpgradeToPlus())
    }

    if (recommendations.length === 0) {
      recommendations.push(this.renderGetAnExpert())
    }

    return (
      <div>
        <h4 className="recommended-jobs__title">Recommended for you</h4>
        <div className="recommended-jobs__container">
          {recommendations}
        </div>
      </div>
    )
  }

  renderUpgradeToPlus() {
    const jobType = 'Plus Upgrade'
    AnalyticsUtils.recommendedJobViewed(jobType)

    return (
      <Card key='plusupgrade' className='recommended-job-card' style={{borderRadius: 10}} onTouchTap={ () => { this.context.router.push('/plus/upgrade') } }>
        <CardMedia style={{ height: '50px', borderRadius: '10px 10px 0 0', backgroundImage: 'url(https://dropshare-daniel.s3-eu-west-1.amazonaws.com/WItO67zDAy.png)' }}>
      </CardMedia>
        <CardTitle
          title={<h2 className="small-spacing2">Upgrade to Plug in SEO Plus</h2>}
          subtitle='$20/month'
          style={{paddingBottom: 12}}
        />
        <CardText style={{padding: '0 16px'}}>
          <ul className='icon-font-list'>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>SEO enhancements to your shop out-of-the-box</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>The most powerful SEO management for Shopify</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>All key areas covered: structure data, page titles, meta descriptions and more</li>
          </ul>
        </CardText>
        <CardActions style={{padding: 16}}>
          <Button
            label="Learn more"
            buttonType="secondary"
            onTouchTap={ () => {
              AnalyticsUtils.learnMoreButtonClicked(jobType)
              this.context.router.push('/plus/upgrade')
            } }
          />
        </CardActions>
      </Card>
    )
  }

  renderGetAnExpert() {
    const jobType = "Get Expert"
    AnalyticsUtils.recommendedJobViewed(jobType)

    return (
      <Card key='getexpert' className='recommended-job-card' style={{borderRadius: 10}} onTouchTap={ () => { location.href = 'https://www.blimpon.com' } }>
        <CardMedia style={{ height: '50px', borderRadius: '10px 10px 0 0', backgroundColor: '#1E88E5' }}>
      </CardMedia>
        <CardTitle
          title={<h2 className="small-spacing2">Find an expert to improve your SEO and your shop</h2>}
          subtitle='small tweaks from $79, custom projects from $500'
          style={{paddingBottom: 12}}
        />
        <CardText style={{padding: '0 16px'}}>
          <ul className='icon-font-list'>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>As Shopify Experts we've fixed over 2,000 shops</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Experienced in adding features, fixing issues and SEO</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Fixed-price quotes with a 100% money-back guarantee</li>
          </ul>
        </CardText>
        <CardActions style={{padding: 16}}>
          <Button
            label="Learn more"
            buttonType="secondary"
            href={Enum.GenerateBlimponUrl('', this.context.currentUser.activeCharge, Enum.BlimponLinkLocations.checksPage)}
            onTouchTap={ () => { Analytics.learnMoreButtonClicked(jobType) } }
          />
        </CardActions>
      </Card>
    )
  }

}



// WEBPACK FOOTER //
// ./app/components/jobs/RecommendedJobs.js